import * as organizationConstants from '../constants/organizations';
import * as organizationsSagas from '../sagas/organizationSagas';

export default function currentOrganizations(
    state = { loadingOrganizations: true },
    action,
) {
    switch (action.type) {
        case organizationConstants.FETCH_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                loadingOrganizations: true,
            };
        case organizationConstants.FETCH_ORGANIZATIONS_SUCCESS:
            const organizations = action.payload;
            return {
                ...state,
                loadingOrganizations: false,
                items: organizations.map(org => org.id),
            };
        case organizationConstants.FETCH_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                loadingOrganizations: false,
                error: true,
            };
        case organizationConstants.FETCH_ORGANIZATION_MEMBERS_REQUEST: {
            const { organizationId } = action.payload;
            const loadingMembers = state.loadingMembers || {};
            return {
                ...state,
                loadingMembers: {
                    ...loadingMembers,
                    [organizationId]: true,
                },
            };
        }
        case organizationConstants.FETCH_ORGANIZATION_MEMBERS_SUCCESS:
        case organizationConstants.FETCH_ORGANIZATION_MEMBERS_FAILURE: {
            const { organizationId } = action.payload;
            const loadingMembers = state.loadingMembers || {};
            const error =
                action.type ===
                organizationConstants.FETCH_ORGANIZATION_MEMBERS_FAILURE;
            return {
                ...state,
                error,
                loadingMembers: {
                    ...loadingMembers,
                    [organizationId]: false,
                },
            };
        }
        case organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_REQUEST: {
            const { organizationId } = action.payload;
            const loadingInvitations = state.loadingInvitations || {};
            return {
                ...state,
                loadingInvitations: {
                    ...loadingInvitations,
                    [organizationId]: true,
                },
            };
        }
        case organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS:
        case organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_FAILURE: {
            const { organizationId } = action.payload;
            const loadingInvitations = state.loadingInvitations || {};
            const error =
                action.type ===
                organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_FAILURE;
            return {
                ...state,
                error,
                loadingInvitations: {
                    ...loadingInvitations,
                    [organizationId]: false,
                },
            };
        }
        case organizationConstants.FETCH_ORGANIZATION_BUCKETS_REQUEST: {
            const { organizationId } = action.payload;
            const loadingBuckets = state.loadingBuckets || {};
            return {
                ...state,
                loadingBuckets: {
                    ...loadingBuckets,
                    [organizationId]: true,
                },
            };
        }
        case organizationConstants.FETCH_ORGANIZATION_BUCKETS_SUCCESS:
        case organizationConstants.FETCH_ORGANIZATION_BUCKETS_FAILURE: {
            const { organizationId, buckets, page } = action.payload;
            const loadingBuckets = state.loadingBuckets || {};
            const pages = state.pages || {};
            const error =
                action.type ===
                organizationConstants.FETCH_ORGANIZATION_BUCKETS_FAILURE;
            return {
                ...state,
                error,
                loadingBuckets: {
                    ...loadingBuckets,
                    [organizationId]: false,
                },
                pages: {
                    ...pages,
                    [organizationId]: {
                        page: page || 0,
                        more:
                            buckets.length ===
                            organizationsSagas.BUCKET_PAGE_SIZE,
                    },
                },
            };
        }
        case organizationConstants.FETCH_BUCKET_REQUEST: {
            const { organizationId } = action.payload;
            const loadingBuckets = state.loadingBuckets || {};
            return {
                ...state,
                loadingBuckets: {
                    ...loadingBuckets,
                    [organizationId]: true,
                },
            };
        }
        case organizationConstants.FETCH_BUCKET_SUCCESS:
        case organizationConstants.FETCH_BUCKET_FAILURE: {
            const loadingBuckets = state.loadingBuckets || {};
            const error =
                action.type === organizationConstants.FETCH_BUCKET_FAILURE;
            return {
                ...state,
                error,
                loadingBuckets: {
                    ...loadingBuckets,
                    [action.payload.organizationId]: false,
                },
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/currentOrganizationsReducer.js